module.exports = __webpack_public_path__ + "static/media/proj20_img9.cf756383.jpg";